export default __webpack_public_path__ + "static/media/Thaumaturge's Leggings of Imperial Assent.7ffd8b7b.jpg";